import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  ChangePasswordRequest,
  ChangePasswordResponse
} from './changePassword.types'

export const changePassword = async (data: ChangePasswordRequest) => {
  const response = await authApi.put<ChangePasswordResponse>(
    '/innos/change-password',
    data
  )
  return response.data
}

export const useChangePasswordMutation = (
  options?: ExtendableMutationOptions<
    ChangePasswordResponse,
    ChangePasswordRequest
  >
) => {
  return useMutation({
    mutationFn: changePassword,
    ...options
  })
}
